import React from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { ClassNameMap, IconButton, styled, Typography } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';

const StyledMuiDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute' as const,
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

type DialogTitleProps = {
  children: React.ReactNode;
  id?: string;
  onClose: () => void;
  classes?: ClassNameMap<string>;
};

const AddGpcDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;
  return (
    <StyledMuiDialogTitle {...(other as any)} component="div">
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <StyledIconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </StyledIconButton>
      ) : null}
    </StyledMuiDialogTitle>
  );
};

export default AddGpcDialogTitle;
